export default "__VITE_ASSET__CaiDcgkb__"